import http from '../../plugins/axios';

export default {

    /** 获取所有的配置*/
    getAllConfig() {
        return http.get({
            url: '/admin/quotationSync/allConf'
        })
    },

    /** 更新某一个交易对的配置*/
    updatePairConfig(data) {
        return http.post({
            url: '/admin/quotationSync/update',
            data,
            dataType: 'form'
        })
    },

    queryMachineSwitch(){
        return http.get({
            url: '/admin/machine/switch/query'
        })
    },

    saveMachineSwitch(data){
        return http.post({
            url: '/admin/machine/switch/save',
            data,
            dataType: 'form'
        })
    },

    queryMachineProjectInfo(data){
        return http.get({
            url: '/admin/traders/projects/query',
            data,
        })
    },

    updateMachineProjectInfo(data){
        return http.post({
            url: '/admin/traders/projects/alter',
            data,
            dataType: 'form'
        })
    },

    insertMachineProjectInfo(data) {
        return http.post({
            url: '/admin/traders/projects/insert',
            data,
            dataType: 'form'
        })
    },

    /** 刷量策略配置 */
    queryBrushConfig() {
        return http.get({
            url: '/admin/quotationSync/brush/query',
        })
    },

    saveBrushConfig(data) {
        return http.post({
            url: '/admin/quotationSync/brush/conf',
            data,
            dataType: 'form'
        })
    },

    savePairDepthDealConfig(data) {
        return http.post({
            url: '/admin/quotationSync/save/pair/depth/deal/config',
            data,
            dataType: 'form'
        })
    },

    export2Excel(name,columns,list){
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../excel/Export2Excel');
            let tHeader = []
            let filterVal = []
            if(!columns){
                return;
            }
            columns.forEach(item =>{
                tHeader.push(item.title)
                filterVal.push(item.key)
            })
            const data = list.map(v => filterVal.map(j => v[j]))
            export_json_to_excel(tHeader, data, name);
        })
    },
    // 获取交易深度配置
    getTradeVolume(data) {
        return http.get({
            url: '/admin/depthConfig/findDepthConfigList',
            data
        })
    },
    // 修改深度
    editTradeVolume(data) {
        return http.post({
            url: '/admin/depthConfig/updateDepthConfig',
            data
        })
    },
    addTradeVolume(data) {
        return http.post({
            url: '/admin/depthConfig/addDepthConfig',
            data
        })
    },
    // 查询指数价
    getPrice(data) {
        return http.get({
            url: '/admin/quotationSync/pair/priceInfo',
            data,
            noLoading: true
        })
    }
}
